import React from 'react';

import { getResultsPage } from './listUtils';

function InputFilter({ name, text, onChange }) {
    return <input id={name} onChange={onChange} value={text} placeholder="Search..." />;
}

function OptionFilter({ id, value = '', values, onFilterChange }) {
    const options = values.map((option) => (
        <option value={option} key={option}>{option}</option>
    ));

    return (
        <select key={id} id={id} value={value} onChange={onFilterChange}>
            <option value="" key="none"></option>
            {options}
        </select>
    );
}

export default function DirectoryTable({
    items,
    years = {},
    page,
    pageSize,
    filters = {},
    onFilterChange,
    columns = [],
}) {
    const yearsHeaders = Object.keys(years).map((year) => <th key={year}>{year}</th>);
    const yearsFilters = Object.keys(years).map((year) => (
        <th key={year} className="year">
            <OptionFilter
                key={year}
                id={year}
                value={filters?.[year] || ''}
                values={years[year]}
                onFilterChange={onFilterChange}
            />
        </th>
    ));

    const rows = getResultsPage(items, page, pageSize).map((item, index) => (
        <tr key={item.id ?? index}>
            {columns.map((column) => (
                <td key={`${item.id ?? index}-${column.key}`}>
                    {column.render ? column.render(item) : item[column.field] ?? ''}
                </td>
            ))}
            {Object.keys(years).map((year) => (
                <td key={`${item.id ?? index}-${year}`} className="year">
                    {item.history?.[year] ?? ''}
                </td>
            ))}
        </tr>
    ));

    return (
        <table>
            <thead>
                <tr key="headings">
                    {columns.map((column) => (
                        <th key={column.key}>{column.label}</th>
                    ))}
                    {yearsHeaders}
                </tr>
                <tr key="filters">
                    {columns.map((column) => (
                        <th key={column.key}>
                            {column.filterable ? (
                                <InputFilter
                                    name={column.key}
                                    text={filters?.[column.key] || ''}
                                    onChange={onFilterChange}
                                />
                            ) : null}
                        </th>
                    ))}
                    {yearsFilters}
                </tr>
            </thead>
            <tbody>{rows}</tbody>
        </table>
    );
}
